var map = {
	"./Art.webp": 9752,
	"./Computer Science & Engineering.webp": 5133,
	"./History.webp": 9201,
	"./Language.webp": 6225,
	"./Literature.webp": 8456,
	"./Math.webp": 9841,
	"./Other.webp": 5639,
	"./Science.webp": 4967,
	"./defaultProfile.webp": 613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7723;